import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import * as _ from 'underscore';
import { Subject } from 'rxjs';
import { AlertService } from 'src/app/_services/alert.service';
import { CorporateService } from 'src/app/_services/corporate/corporate.service';


export class Person {
  id: number;
  firstName: string;
  lastName: string;
}

@Component({
  selector: 'app-datatable',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.css']
})
export class DatatableComponent implements OnInit {
  @Input() tableHeaders: Array<string> = [];
  @Input() tableData: any;
  @Input() tableOptionsSettings: Object;
  @Input() columnDataMapping: any = {};
  @Output() rowClicked = new EventEmitter<any>();
  dtTrigger: Subject<any> = new Subject<any>();
  dtOptions: DataTables.Settings = {};

  public breadcrumb: any;
  responseData: any = [];
  currOrganization: any;
  startDate: any = moment().subtract(7, 'days').format('YYYY-MM-DD');
  endDate: any = moment().format('YYYY-MM-DD');

  constructor(
    private corporateService: CorporateService,
    private router: Router,
    private alertService: AlertService,
  ) {
    if (window.localStorage.getItem('currOrganization')) {
      this.currOrganization = JSON.parse(window.localStorage.getItem('currOrganization'));
    }
  }

  ngOnInit(): void {
    this.dtOptions = this.tableOptionsSettings;
    if(this.tableData) {

      this.responseData = this.tableData;
    } else {
      this.loadRoomData();
    }
  }

  loadRoomData() {
    this.corporateService.getBudgetMasterData()
    .then((res: any) => {
       this.responseData = res;
      this.dtTrigger.next();
    })
  }

  readableDateFormat(userDate: any) {
    if (!_.isObject(userDate)) {
      return userDate;
    } else {
      let year = userDate.year;
      let month = userDate.month <= 9 ? '0' + userDate.month : userDate.month;;
      let day = userDate.day <= 9 ? '0' + userDate.day : userDate.day;;
      let finalDate = day + "-" + month + "-" + year;
      return finalDate;
    }
  }

  newGroup() {
    localStorage.setItem("groupId", null);
    this.router.navigate(['/c/group/create']);
  }

  updateItem(item: any) {
    // item.isRead = !item.isRead
    this.corporateService.updateGroupData(item)
      .then(() => {
        if (item.isConfirmed) {
          this.alertService.showSuccess('Room Entry Acknowledged successfully !')
        }
      })
  }

  rowSelected(resp) {
    this.rowClicked.emit(resp);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

}
